<template>
  <div class="nav-part" id="navPart">
    <div class="nav-part-img">
      <img src="../../assets/images/home/nav-logo.png" alt="logo" />
      <span class="nav-part-img-title">海南高速公路工程建设集团有限公司</span>
    </div>
    <div class="nav-part-list-self">

      <div class="nav-part-list-self-item" v-for="item in navList" :key="item.path" @click="jumpTo(item.path)">
        {{ item.label }}
      </div>
      <div style="display:flex;height: 0.44rem;align-items: center; position: relative; gap: 0.15rem;">
        <!-- 搜索图标 -->
        <div style="width: 0.41rem; height: 0.41rem; background: #054899; border-radius: 50%; display: flex; align-items: center; justify-content: center; cursor: pointer;" @click="search">
          <img src="../../assets/images/home/icon_04.png" alt="搜索" style="width: 0.2rem; height: 0.2rem;" />
        </div>

        <!-- 用户图标 -->
        <div style="width: 0.86rem; height: 0.41rem; border: solid 0.01rem #054899; background: #f5f5f5; border-radius: 0.2rem; display: flex; align-items: center; justify-content: center; cursor: pointer; gap: 0.05rem;" @click="handleUserAction">
          <img src="../../assets/images/home/icon_05.png" alt="用户" style="width: 0.2rem; height: 0.2rem;" />
          <span style="font-size: 0.16rem; color: #054899;">{{ username ? '退出' : '登录' }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { getFileAccessHttpUrl } from "@/assets/js/api/manage"

export default {
  data() {
    return {
      navList: [
        { path: "/", label: "首页" },
        { path: "/layout/collectionHall", label: "集采大厅" },
        { path: "/layout/notice", label: "通知公告" },
        { path: "/layout/helpCenter", label: "帮助中心" },
        { path: "/layout/userCenter", label: "用户中心" },
        { path: "/layout/aboutUs", label: "关于我们" }
      ],
      username: '',
      phone: '',
      tendertitte: ''
    };
  },
  created() {
    this.username = localStorage.getItem('username')
    this.phone = localStorage.getItem('phone')
  },
  computed: {
    isCollecteHallList() {
      return this.$route.path == '/layout/collectionHall/list'
    }
  },
  methods: {
    jumpTo(path) {
      this.$router.push(path)
    },
    onloginout() {
      this.$Modal.confirm({
        title: '提示',
        content: '确认退出？',
        onOk: () => {
          this.$store.dispatch('Logout').then(() => {
            this.$router.push('/login')
          })
        }
      })
    },
    search() {
      console.log(this.isCollecteHallList)
      if (!this.isCollecteHallList) {
        this.$router.push('/layout/collectionHall/list')
      }
      this.$store.commit('SET_TENDERTITTLE', this.tendertitte)
    },
    ...mapGetters(["avatar"]),
    getAvatar() {
      let url = localStorage.getItem('avatar')
      if (url == null || url === 'null') {
        console.log('avatar is null ')
        url = require('../../assets/images/home/avatar-mini.png')
      } else {
        url = getFileAccessHttpUrl(localStorage.getItem('avatar'))
      }
      return url
    },
    handleUserAction() {
      if (!this.username) {
        this.$router.push('/login')
      } else {
        // 可以显示用户菜单或直接退出
        this.onloginout()
      }
    }
  }
};
</script>

<style lang="less" scoped>
.nav-part {
  align-items: center;
  width: 17.3rem;
  margin-bottom: 0.18rem;

  &-img {
    width: 5.4rem;
    height: 0.45rem;
    margin-left: 0.2rem;
    margin-top: 0.1rem;
    display: flex;

    img {
      width: 1.28rem;
      height: 100%;
    }

    &-title {
      font-family: 'AlibabaPuHuiTi';
      font-size: 0.22rem;
      font-weight: bold;
      line-height: 0.4rem;
      letter-spacing: 0px;
      color: #333333;
      margin-left: 0.15rem;
      position: relative;
      padding-left: 0.2rem;

      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 0.02rem;
        height: 0.43rem;
        background-color: #dddddd;
        opacity: 0.4;
      }
    }
  }

  &-list-self {
    width: 9rem;
    height: 0.44rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-family: AlibabaPuHuiTiR;
    font-size: 0.18rem;
    font-weight: normal;
    font-stretch: normal;
    // line-height: .8rem;
    letter-spacing: 0px;
    color: #333333;

    &-item {
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/navPart/index.vue